<template>
  <div id="app" class="app">
    <Score v-if="hasWon || hasLost"></Score>
    <Board v-else-if="board"></Board>
    <Menu v-else></Menu>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Board from '@/components/Board.vue';
  import Menu from '@/components/Menu.vue';
  import Score from '@/components/Score.vue';


  export default {
    name: 'app',
    components: {
      Board,
      Menu,
      Score,
    },
    computed: {
      ...mapGetters([
        'board',
        'hasWon',
        'hasLost',
      ]),
    },
    created() {
      // See https://stackoverflow.com/a/51093815/1007003
      window.document.body.addEventListener('mousedown', this.addMouseControlClass);
      window.document.body.addEventListener('keydown', this.removeMouseControlClass);
    },
    destroyed() {
      // See https://stackoverflow.com/a/51093815/1007003
      window.document.body.removeEventListener('mousedown', this.addMouseControlClass);
      window.document.body.removeEventListener('keydown', this.removeMouseControlClass);
    },
    methods: {
      addMouseControlClass() {
        window.document.body.classList.add('using-mouse');
      },
      removeMouseControlClass() {
        window.document.body.classList.remove('using-mouse');
      },
    },
  };
</script>

<style lang="scss">
  @import "~normalize.css/normalize.css";
  @import "config/styles/settings";
  @import "config/styles/util";

  *, *:after, *:before {
    box-sizing: border-box;
  }

  html, .app {
    height: 100%;
  }

  .app {
    min-height: 100%;
    background: $blue-100 linear-gradient(to top, #{$blue-100}, #{$blue-200});
  }

  body {
    margin: 0;
    padding: 0;
    height: 100%;
    min-height: 100%;
    background: $blue-100;
    font-size: $rem-base;
    font-family: 'Rubik', sans-serif;
    color: $gray-800;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Monoton', cursive;
    font-weight: normal;
  }

  [hidden], [v-cloak] {
    display: none;
  }

  // Disable focus outlines for mouse controls.
  // See https://stackoverflow.com/a/51093815/1007003
  body.using-mouse :focus {
    outline: none;
  }
</style>
